
<!-- <body> -->

    <div class="bodyContainer">
        <div class="overallDataContainer">
            <span class="textFont text_blue_color">Grievance Dashboard</span>
        </div>
        <div class=" dataContainer">
            <span class="subDataContainer box_shadow" *ngFor="let item of grievanceData">
                <div class="imageContainer">
                    <img class="imgIcon"
                        [style.width.%]="item.statusName === 'IN PROGRESS' || item.statusName === 'ESCALATED' ? 14 : null"
                        [src]="getIcon(item.statusName)" alt="">
                    <div class="flex_col">
                        <span style="font-size: 24px;">{{ item.count }}</span>
                        <span>{{ item.statusName |uppercase }}</span>
                    </div>
                </div>
                <div style="margin-left: 10%;">
                    <div
                        style="display: flex; height: 6px; width: 90%; border-radius: 10px; background-color: #D9D9D9;">
                        <div [style.backgroundColor]="getBarColor(item.statusName)"
                            [style.width.%]="item.trackPercentage" style="border-radius: 10px;"></div>
                    </div>
                    <!-- <span>Overdue: <span style="color: #AA1FC2;">5</span></span> -->
                </div>
            </span>

        </div>
        <div class="dataContainer">
            <div class="subDataContainer box_shadow graphHeight border">
                <span class="graphtitledata">Overall Status</span>
                <hr>
                <div id="pieChart"></div>
                <div style="display: flex; flex-direction: row;flex-wrap: wrap;justify-content: center;">
                    <span style="display: flex; flex-direction: row; gap: 5px;">
                        <div style="background-color: #026FD4; border:1px solid #026FD4" class="dot"></div>
                        <span style="font-size: 11px;">Open</span>
                    </span>
                    <span style="display: flex; flex-direction: row;gap: 5px;">
                        <div style="background-color: #0CA766; border:1px solid #0CA766" class="dot"></div>
                        <span style="font-size: 11px;">Resolved</span>
                    </span>
                    <span style="display: flex; flex-direction: row;gap: 5px;">
                        <div style="background-color: #FB9D05; border:1px solid #FB9D05" class="dot"></div>
                        <span style="font-size: 11px;">In Progress</span>
                    </span>
                </div>

            </div>
            <div class="largeSubDataContainer box_shadow graphHeight border">
                <span class="graphtitledata">Month wise Performance</span>
                <hr>
                <div class="monthlyTab">
                    <span style="border-bottom: 6px solid #FF333A;padding-right: 3px;">1M</span>
                    <span>3M</span>
                    <span>6M</span>
                </div>
                <div id="barGraph"></div>
                <div
                    style="display: flex; flex-direction: row;flex-wrap: wrap; justify-content: center;padding-top: 10px;">
                    <span style="display: flex; flex-direction: row; gap: 5px;">
                        <div style="background-color: #026FD4; border:1px solid #026FD4" class="dot"></div>
                        <span style="font-size: 11px;">Open</span>
                    </span>
                    <span style="display: flex; flex-direction: row;gap: 5px;">
                        <div style="background-color: #0CA766; border:1px solid #0CA766" class="dot"></div>
                        <span style="font-size: 11px;">Resolved</span>
                    </span>
                    <span style="display: flex; flex-direction: row;gap: 5px;">
                        <div style="background-color: #FB9D05; border:1px solid #FB9D05" class="dot"></div>
                        <span style="font-size: 11px;">In Progress</span>
                    </span>
                    <span style="display: flex; flex-direction: row;gap: 5px;">
                        <div style="background-color: #FF333A; border:1px solid #FF333A" class="dot"></div>
                        <span style="font-size: 11px;">Escalated</span>
                    </span>
                </div>
            </div>
            <div class="subDataContainer graphHeight border box_shadow">
                <span class="graphtitledata">Resolution timeline</span>
                <hr>

                <div id="lineGraph">
                    
                </div>
            </div>
        </div>
        <div class="content box_shadow table_container">
            <span class="graphtitledata">Grievance Track Details</span>
            <hr>
            <input type="text " class="input " (input)="onQuickFilterChanged($event)" placeholder="Search..." />
            <!-- The AG Grid component, with Dimensions, CSS Theme, Row Data, and Column Definition -->
            <ag-grid-angular style="width: 98%; height:450px; overflow-x: scroll; margin-left: 1%;" [rowData]="rowData"
                [pinnedTopRowData]="pinnedTopRowData" [columnDefs]="colDefs" [defaultColDef]="defaultColDef"
                [quickFilterText]="quickFilter" />
        </div>
    </div>
<!-- </body> -->

<!-- =======Loading ========== -->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>